import { Delete, Edit } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  TextField,
} from "@mui/material";
import { currency } from "../../MUI_components/currencyFormatterTag";
import { NumFormat } from "../../MUI_components/currencyFormat";
import FromControl from "../../MUI_components/FormControl/fomikFormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

import { Field, Form, Formik, FieldArray } from "formik";
import { handleLineTotal } from "Components/Constants/constatnFunctions";
import { handleRetailTotal } from "Components/Constants/constatnFunctions";

const PREFIX = "AddingStockTable";
const classes = {
  table: `${PREFIX}-table`,
};

export default function SpanningTable({ data, remove, setStock, code, grnValue, setGrnValue }) {
  const handleChangeDiscountAmount = (event) => {
    setGrnValue({
      ...grnValue,
      discountAmount: event.target.value
    });
  };

  const handleChangeDiscountPercentage = (event) => {
    setGrnValue({
      ...grnValue,
      discountPercentage: event.target.value
    });
  };

  function total(data) {
    return data
      .map(({ quantity, costPrice, discountAmount, discountPercentage }) =>
        ((quantity * costPrice) - (discountAmount * quantity)) - ((quantity * costPrice) * (discountPercentage / 100)))
      .reduce((sum, i) => sum + i, 0);
  }

  //This is GRN Level discount
  function callDiscountAmount(data) {

    let disAmt = grnValue.discountAmount;
    let disPer = grnValue.discountPercentage;
    let subTotal = total(data);
    let amt = (disPer / 100 * subTotal) + parseFloat(disAmt ? disAmt : 0);// discountAmount;
    
    return amt;

  }
  const CustomInput = (props) => {
    return (
      <input
        type="number"
        style={{
          fontSize: 12,
          width: props.width ? props.width : 50,
          maxWidth: 200,
        }}
        step="any"
        {...props}
        className="custom-input"
      />
    );
  };
  return (
    <TableContainer>
      <Table className={classes.table} size="small" aria-label="spanning table">
        <TableHead style={{ backgroundColor: "#cacaca50" }}>
          <TableRow>
            <TableCell width="5"></TableCell>
            <TableCell>#</TableCell>
            <TableCell>Item name</TableCell>
            <TableCell align="right">Qty.</TableCell>
            <TableCell align="right">Free</TableCell>
            <TableCell align="right">Total Qty</TableCell>
            <TableCell align="right">Cost Price</TableCell>
            <TableCell align="right">Retail Price</TableCell>
            <TableCell align="right">Dis %</TableCell>
            <TableCell align="right">Dis Amt</TableCell>
            <TableCell align="right">Retail Sum</TableCell>
            <TableCell align="right">Cost Sum</TableCell>
          </TableRow>

        </TableHead>
        <TableBody>
  {[...data].reverse().map((row, index, arr) => {
    const descendingIndex = arr.length - index - 1; // Adjusted to match the original index

    return (
      <TableRow key={index}>
        <TableCell>
          <div className="flex">
            {!code && (
              <Delete
                color="secondary"
                style={{ fontSize: 18, cursor: "pointer" }}
                onClick={() => {
                  if (window.confirm("Are you sure want to delete this?"))
                    remove(descendingIndex); // Use descendingIndex here
                }}
              />
            )}
            <Edit
              color="primary"
              style={{ fontSize: 18, cursor: "pointer" }}
              onClick={() => {
                setStock({ ...data[descendingIndex], editIndex: descendingIndex }); // Use descendingIndex here
              }}
            />
          </div>
        </TableCell>
        <TableCell>{descendingIndex + 1}</TableCell> {/* Adjusted for 1-based index */}
        <TableCell>{row.itemMaster.name}</TableCell>
        <TableCell align="right">{row.quantity}</TableCell>
        <TableCell align="right">{row.freeQuntity}</TableCell>
        <TableCell align="right">{parseFloat(row.quantity) + parseFloat(row.freeQuntity)}</TableCell>
        <TableCell align="right">{currency(row.costPrice)}</TableCell>
        <TableCell align="right">{currency(row.retailPrice)}</TableCell>
        <TableCell align="right">{row.discountPercentage}</TableCell>
        <TableCell align="right">{currency(row.discountAmount)}</TableCell>
        <TableCell align="right">
          {currency(handleRetailTotal(
            parseFloat(row.quantity),
            parseFloat(row.freeQuntity),
            row.retailPrice,
          ))}
        </TableCell>
        <TableCell align="right">
          {currency(handleLineTotal(
            row.quantity,
            row.costPrice,
            row.discountPercentage,
            row.discountAmount
          ))}
        </TableCell>
      </TableRow>
    );
  })}

  {data.length === 0 ? (
    <TableRow>
      <TableCell align="center" colSpan={7}>
        <strong>No Data</strong>
      </TableCell>
    </TableRow>
  ) : (
    <>
      <TableRow>
        <TableCell colSpan={6} rowSpan={3} />
        <TableCell colSpan={5}>
          Sub Total
        </TableCell>
        <TableCell align="right">
          {currency(total(data))}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={2}>Bill Discount</TableCell>
        <TableCell align="right" colSpan={2}>Dis %
          <TextField id="standard-basic"
            value={grnValue.discountPercentage}
            onChange={handleChangeDiscountPercentage}
            variant="standard" />
        </TableCell>

        <TableCell align="right">Dis Amt
          <TextField id="standard-basic"
            value={grnValue.discountAmount}
            onChange={handleChangeDiscountAmount}
            variant="standard" />
        </TableCell>
        <TableCell align="right">
          <strong>{currency(callDiscountAmount(data))}</strong>
        </TableCell>
      </TableRow>

      <TableRow style={{ backgroundColor: "#cacaca50", }}>
        <TableCell colSpan={5}>
          <strong>Total</strong>
        </TableCell>
        <TableCell align="right">
          <strong>{currency(total(data) - callDiscountAmount(data))}</strong>
        </TableCell>
      </TableRow>
    </>
  )}
</TableBody>


      </Table>
    </TableContainer>
  );
}